<template>
  <div id="app">
    <v-app>
        <router-view/>
    </v-app>
  </div>
</template>

<script>
  import checkBuildHash from './mixins/checkBuildHash';

  export default {
    name: 'App',
    mixins: [checkBuildHash],



    metaInfo: {
        titleTemplate: '%s - Harmony Fan',
        title: 'Inicio',
        meta: [
            { charset: 'utf-8' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' },
            { vmid: 'description', name: 'description', content: 'Harmony fan es una herramienta que te permite con un solo Clic conectar tu audiencia con tus plataformas y ganar dinero al hacerlo.' },
            // Metaetiquetas sociales por defecto (vmid permite que cada perfil las reemplace)
            { vmid: 'og:title', property: 'og:title', content: 'Harmony Fan' },
            { vmid: 'og:description', property: 'og:description', content: 'Harmony fan es una herramienta que te permite con un solo Clic conectar tu audiencia con tus plataformas y ganar dinero al hacerlo.' },
            { vmid: 'og:image', property: 'og:image', content: 'https://backend.harmony.fan/storage/images/harmony.png' },
            { vmid: 'og:url', property: 'og:url', content: 'https://harmony.fan/' },
            { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
        ],
        link: [
          {
            rel: 'icon',
            type: 'image/x-icon',
            href: './favicon.ico'
          }
        ]
    }
  };
</script>

<style lang="scss">

    #app {
        //font-family: Avenir, Helvetica, Arial, sans-serif;
        font-family: Rubik, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        //color: #2c3e50;
    }

    .v-btn {
        text-transform: none !important;
    }

    .swal2-title {
        font-family: Rubik, sans-serif;
    }

    .swal2-html-container {
        font-family: Rubik, sans-serif;
    }

    .swal2-styled{
        font-family: Rubik, sans-serif;
    }

    .swal2-confirm {
        font-weight: 400 !important;
    }

    .swal2-cancel {
        font-weight: 400 !important;
    }

    ::-moz-selection { /* Code for Firefox */
        color: white;
        background: #8e84c0;
    }

    ::selection {
        color: white;
        background: #8e84c0;
    }

    .title-main-hero span {
        display: block;
        font-size: 53px;
        font-weight: 800;
    }

    .title-second-hero span {
        display: block;
        font-size: 48px;
        font-weight: 800;
    }

    ::-webkit-scrollbar {
        width: 5px;
    }

    ::-webkit-scrollbar-track {
        background-color: #e7e7e7;
        -webkit-border-radius: 10px;
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
        -webkit-border-radius: 10px;
        border-radius: 10px;
        background: #bdbdbd;
    }

    .input-capitalize input {
        text-transform: capitalize;
    }

</style>
